import React from 'react';

import OrganisationProfile from '@components/OrganisationProfile';

import { useSettings } from '@hooks/useSettings';

import { IOrganisationProfile } from '@interfaces/organisation/organisations';

import styles from './Settings.module.scss';

const Settings = () => {
	const {
		profile,
		isLoadingProfile,
		handleUpdateOrganisation,
		isLoadingUpdateOrganisation,
	} = useSettings();

	return (
		<div className={styles.settingsContainer}>
			<OrganisationProfile
				handleUpdateOrganisation={handleUpdateOrganisation}
				isLoadingProfile={isLoadingProfile}
				isLoadingUpdateOrganisation={isLoadingUpdateOrganisation}
				isSettings
				organisationId={profile.id}
				profile={profile as IOrganisationProfile}
			/>
		</div>
	);
};

export default Settings;
